import React from 'react';

const newsItems = [
  {
    date: '27 листопада 2025',
    title: 'Нова функція: зовнішній лічильник онлайн-слухачів',
    paragraphs: [
      'Ми додали нову можливість для радіостанцій — зовнішній лічильник онлайн-слухачів, який можна розмістити на будь-якому сайті, у віджеті або плеєрі.',
      'Підключення максимально просте: у кабінеті на сторінці Live Service натисніть кнопку «Отримати зовнішній лічильник», і система автоматично надішле на вашу пошту персональне посилання для підключення.',
      'Лічильник легко інтегрується у будь-який дизайн, оскільки він повертає лише числове значення кількості слухачів, а візуальна частина повністю залишається на вашому боці.',
      'Функція вже доступна всім користувачам.'
    ]
  },
  {
    date: '24 листопада 2025',
    title: 'TOP: оновлений сервіс музичних рейтингів для радіостанцій',
    paragraphs: [
      'Ми оновили сервіс музичних рейтингів — тепер він називається TOP.',
      'Що змінилося і стало краще:',
      'Тільки музичні треки. TOP рахує лише реальні пісні, що звучали в ефірі, тож статистика максимально коректно відображає музичну ротацію.',
      'Гнучкий розмір рейтингу. Кожна радіостанція може сама обрати потрібний рейтинг: TOP-10, TOP-20, TOP-40, TOP-50, TOP-100 — або будь-яке інше значення в цьому діапазоні. Це зручно і для внутрішнього програмування ефіру, і для звітів правовласникам та рекламодавцям.',
      'Експорт звітів з урахуванням обраного TOP-N. Обраний розмір рейтингу автоматично застосовується під час експорту: можна завантажити PDF або Excel з тим самим TOP-N, який бачите на екрані.',
      'TOP уже доступний у кабінеті радіостанцій — оберіть місяць, задайте потрібний розмір рейтингу та побудуйте звіт.',
      'Для використання TOP потрібен експорт плейлистів радіостанції.'
    ]
  },
  {
    date: '20 листопада 2025',
    title: 'Нова метрика в Radiomonitor: Average Daily Reach (ADR)',
    paragraphs: [
      'Ми додали в Radiomonitor нову метрику — Average Daily Reach (ADR), яка показує, скільки унікальних слухачів приходять на вашу станцію за обраний період (1 день, 7 днів, 1 місяць тощо).',
      'ADR допомагає побачити реальний охват радіостанції за вибраний період, зрозуміти, скільки слухачів ви реально залучаєте, та аргументовано спілкуватися з рекламодавцями і партнерами, показуючи зрозумілу цифру охоплення.',
      'Метрика ADR буде корисною власникам радіостанцій, комерційним директорам, програмним директорам та маркетологам, які працюють з рекламними кампаніями та розвитком станції.'
    ]
  },
  {
    date: '13 листопада 2025',
    title: 'Новий HTTPS-агент — реальні IP слухачів за захищеним з’єднанням',
    paragraphs: [
      'Ми зробили окремий HTTPS-агент для радіостанцій, які транслюють потоки через захищений протокол HTTPS. Він зчитує реальні IP слухачів із веб-сервера (OpenResty/Nginx або будь-якого іншого джерела логів підключень), поєднує їх із даними Icecast і передає на Radiomonitor вже «очищену» статистику.',
      'Агент працює в окремому Docker-контейнері на боці радіостанції, не має доступу до внутрішніх сервісів Radiomonitor і не передає жодних зовнішніх секретів. Усі налаштування — логіни агента, ідентифікатор станції, шляхи до логів та Icecast — зберігаються лише у локальному конфіг-файлі.',
      'Завдяки цьому HTTPS-потоки отримують ту саму точність обліку, що й звичайні HTTP-потоки: коректні реальні IP, актуальний статус сесій та коректна геоаналітика для кожного слухача.',
      'Нагадуємо, що в нас також є Агент для HTTP, який значно полегшує підключення і передачу статистичних даних на наш сервер статистики.'
    ]
  },
  {
    date: '17 жовтня 2025',
    title: 'Новий сервіс AHA — середньоденний профіль слухання',
    paragraphs: [
      'Додано новий сервіс AHA (Середньоденний профіль слухання за днями тижня). Він показує, як змінюється середня аудиторія радіостанції протягом доби залежно від дня тижня.',
      'Для кожного дня (понеділка, вівторка … неділі) система обчислює середню кількість слухачів по годинах, усереднюючи дані за всі однойменні дні у вибраному періоді.',
      'Сервіс формує як графік, так і теплову таблицю.'
    ]
  },
  {
    date: '16 жовтня 2025',
    title: 'Оновлення методології в «Пікових навантаженнях»',
    paragraphs: [
      'Оновлено методологію розрахунку у сервісі «Пікові навантаження» (розділ Статистика).',
      'Тепер у періодах «тиждень» і «місяць» графіки відображають саме пікові значення одночасних підключень.'
    ]
  },
  {
    date: '15 лютого 2025',
    title: 'Запустили оновлений кабінет статистики',
    paragraphs: [
      'Ми повністю оновили розділ «Кабінет користувача». Тепер усі ключові показники згруповані за блоками, а доступ до них став швидшим завдяки оптимізованим запитам.',
      'Інтерфейс адаптований для планшетів, тому менеджери можуть стежити за живими показниками навіть у дорозі.'
    ]
  },
  {
    date: '28 січня 2025',
    title: 'Моніторинг тиші став точнішим',
    paragraphs: [
      'Ми додали автоматичне калібрування рівнів гучності для кожного потоку. Система враховує попередні показники станції та адаптує пороги тригерів без ручних налаштувань.',
      'Для швидкої оцінки подій доступний новий звіт з маркерами: позначки часу, тривалість та джерело інциденту.'
    ]
  },
  {
    date: '10 грудня 2024',
    title: 'Бета запуск push-сповіщень',
    paragraphs: [
      'Команда підтримки відкрила доступ до push-сповіщень у браузері для подій по статистиці та потоках. Поки функція працює в бета-режимі та потребує активації в кабінеті.',
      'Ми будемо раді вашим відгукам — пишіть на support@radiomonitor.net.'
    ]
  }
];

export default function NewsPageUk({ onSubscribeClick }) {
  return (
    <div
      style={{
        maxWidth: 880,
        margin: '0 auto',
        padding: '40px 24px 80px',
        lineHeight: 1.6,
        color: '#1b1b1f'
      }}
    >
      <h1 style={{ marginBottom: 24, color: '#006e45' }}>Новини Radiomonitor.net</h1>
      <div
        style={{
          marginBottom: 32,
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 16
        }}
      >
        <p style={{ margin: 0, flex: '1 1 320px', lineHeight: 1.6 }}>
          Тут ми ділимося оновленнями платформи, покращеннями сервісів та планами на найближчий час.
        </p>
        <button
          type="button"
          onClick={() => onSubscribeClick?.()}
          style={{
            padding: '12px 20px',
            borderRadius: 12,
            border: 'none',
            background: '#006e45',
            color: '#fff',
            fontSize: 16,
            fontWeight: 700,
            cursor: 'pointer',
            flex: '0 0 auto'
          }}
        >
          Підписка на новини
        </button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
        {newsItems.map((item) => (
          <article key={item.title}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#4a7f6b', textTransform: 'uppercase' }}>
              {item.date}
            </div>
            <h2 style={{ margin: '8px 0 16px', color: '#134b37', fontSize: 24 }}>
              {item.title}
            </h2>
            {item.paragraphs.map((text, idx) => (
              <p key={idx} style={{ marginBottom: 16 }}>
                {text}
              </p>
            ))}
          </article>
        ))}
      </div>
    </div>
  );
}
